module.exports = __webpack_public_path__ + "static/media/sitio-mantenimiento.e7d6cdf4.png";